const DatePicker = require('../../src/js/client/components/DatePicker').default;

exports._datepicker = DatePicker;
